























import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * A modal dialog element
 *
 * You need to take care where to place this element, in order to have it span
 * the whole viewport. In particual any ancestor elements with css attributes
 * of `transform`, `perspective`, or `filter` will lead to styling conflicts.
 */
@Component
export default class ModalDialog extends Vue {
  /** Dialog title */
  @Prop({ type: String, required: true }) title!: String;

  showContent: boolean = false;
}
